import interact from 'interactjs';

// FIXME: refactor all class name
const windowManagerClassName = 'mdi-window-manager__window-container';

export function makeResizable(watchTargetElem, eventTargetElem, { minWidth, minHeight }) {
  interact(eventTargetElem)
    .styleCursor(true) //TODO: need to scrutinize
    .resizable({
      // resize from all edges and corners
      edges: { left: true, right: true, bottom: true, top: false },
      restrictEdges: {
        outer: `.${windowManagerClassName}`,
        endOnly: true,
      },
      restrictSize: {
        min: { width: minWidth, height: minHeight },
      },
      allowFrom: '.truegaze-window__body',
      // margin: 50,
    })
    .on('resizemove', function (event) {
      let x = parseFloat(eventTargetElem.getAttribute('data-x')) || 0;
      let y = parseFloat(eventTargetElem.getAttribute('data-y')) || 0;
      // update the element's style
      eventTargetElem.style.width = event.rect.width + 'px';
      eventTargetElem.style.height = event.rect.height + 'px';
      // translate when resizing from top or left edges
      x += event.deltaRect.left;
      y += event.deltaRect.top;
      eventTargetElem.style.webkitTransform = eventTargetElem.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      eventTargetElem.setAttribute('data-x', x);
      eventTargetElem.setAttribute('data-y', y);
    });
}

export function makeDraggable(watchTargetElem, moveTargetElem) {
  interact(moveTargetElem).draggable({
    restrict: {
      restriction: `.${windowManagerClassName}`,
      endOnly: true,
      elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
    },
    allowFrom: '.mdi-window__header',
    // enable autoScroll
    autoScroll: false,
    // call this function on every dragmove event
    onmove: function dragMoveListener(event) {
      const x = (parseFloat(moveTargetElem.getAttribute('data-x')) || 0) + event.dx;
      const y = (parseFloat(moveTargetElem.getAttribute('data-y')) || 0) + event.dy;

      moveTargetElem.style.webkitTransform = moveTargetElem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      moveTargetElem.setAttribute('data-x', x);
      moveTargetElem.setAttribute('data-y', y);
    },
    // call this function on every dragend event
    onend: function (event) {
      // fore debug.. append p tag including distance info.
      // var textEl = event.target.querySelector('p');
      // textEl &&
      //   (textEl.textContent =
      //     'moved a distance of ' + Math.sqrt((Math.pow(event.pageX - event.x0, 2) + Math.pow(event.pageY - event.y0, 2)) | 0).toFixed(2) + 'px');
    },
  });
}
